import { baseUniDriverFactory } from '../test-utils/utils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';

export const dragHandleUniDriverFactory = (
  base: UniDriver,
  body: UniDriver,
) => {
  const getButton = () => base.$('[data-hook="drag-handle-button"]');

  const getTooltipDriver = () => tooltipDriverFactory(base, body);

  return {
    ...baseUniDriverFactory(base),
    getButton,
    click: () => getButton().click(),
    hover: () => getButton().hover(),
    getTooltipDriver,
    isTooltipEnabled: () => getTooltipDriver().tooltipExists(),
    getTooltipContent: () => getTooltipDriver().getTooltipText(),
    getDisabled: async () => {
      const value = await getButton().attr('data-disabled');
      return value === 'true';
    },
  };
};

export type DragHandleUniDriver = ReturnType<typeof dragHandleUniDriverFactory>;
